module.exports = __webpack_public_path__ + "img/close0.d00a6c72.png";